import { render, staticRenderFns } from "./OEmbed.vue?vue&type=template&id=37b73e90"
import script from "./OEmbed.vue?vue&type=script&lang=ts"
export * from "./OEmbed.vue?vue&type=script&lang=ts"
import style0 from "./OEmbed.vue?vue&type=style&index=0&id=37b73e90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports